export function getValue(value, options) {
  return value && options ? options.find((o) => o.value === value) : null;
}
